var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"container d-flex flex-wrap"},[_c('backtohome'),_c('v-tabs',{attrs:{"centered":"","color":"green"}},[_c('v-tab',{attrs:{"href":"#kaffee"}},[_vm._v("Kaffee | coffee")]),_c('v-tab-item',{attrs:{"value":"kaffee"}},[_c('kaffee')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }